import { PageHeader } from "@/components/page-header";
import { CsvImporter } from "@/components/csv-importer";

type Row = {
  name?: string; firstName?: string; lastName?: string; salutation?: string;
  email?: string; phone?: string; mobile?: string;
  title?: string; degree?: string; linkedinUrl?: string; accountName?: string;
  leadSource?: string; description?: string; tags?: string;
  solutions?: string; cbcOfferings?: string; contactGeography?: string;
  mailingStreet?: string; mailingCity?: string; mailingState?: string; mailingZip?: string; mailingCountry?: string;
  otherStreet?: string;   otherCity?: string;   otherState?: string;   otherZip?: string;   otherCountry?: string;
};

// Lowercase header → field mapping. Matches Zoho's column names + common synonyms.
const FIELD_MAP: Record<string, keyof Row> = {
  // Name
  "name": "name", "contact name": "name", "full name": "name", "contact": "name",
  "first name": "firstName", "firstname": "firstName",
  "last name": "lastName", "lastname": "lastName",
  "salutation": "salutation",
  // Contact
  "email": "email", "email address": "email", "e-mail": "email",
  "phone": "phone", "work phone": "phone", "phone number": "phone",
  "mobile": "mobile", "cell": "mobile", "mobile phone": "mobile",
  "title": "title", "job title": "title", "position": "title", "role": "title",
  "degree": "degree",
  "linkedin": "linkedinUrl", "linkedin url": "linkedinUrl", "linkedin profile": "linkedinUrl", "linkedinurl": "linkedinUrl",
  // Account
  "company": "accountName", "account": "accountName", "account name": "accountName", "organization": "accountName", "company name": "accountName",
  // Attribution
  "lead source": "leadSource", "source": "leadSource",
  "description": "description", "notes": "description",
  "tag": "tags", "tags": "tags",
  "solutions": "solutions",
  "cbc offerings": "cbcOfferings",
  "contact geography": "contactGeography", "geography": "contactGeography", "region": "contactGeography",
  // Mailing
  "mailing street": "mailingStreet", "street": "mailingStreet", "address": "mailingStreet",
  "mailing city": "mailingCity", "city": "mailingCity",
  "mailing state": "mailingState", "state": "mailingState",
  "mailing zip": "mailingZip", "zip": "mailingZip", "postcode": "mailingZip", "postal code": "mailingZip",
  "mailing country": "mailingCountry", "country": "mailingCountry",
  // Other
  "other street": "otherStreet",
  "other city": "otherCity",
  "other state": "otherState",
  "other zip": "otherZip",
  "other country": "otherCountry",
};

export default function ContactImportPage() {
  return (
    <>
      <PageHeader
        title="Import Contacts"
        description="Upload a Zoho-style CSV — headers for name, email, phone, title, linkedin, company, mailing address, tags, and more are all matched."
      />
      <CsvImporter<Row>
        module="Contacts"
        endpoint="/contacts/bulk-import"
        backTo="/contacts"
        listQueryKey={["/contacts"]}
        fieldMap={FIELD_MAP}
        requiredField={(r: Row) => !!(r.name || r.firstName || r.lastName)}
        description="Dedupes by email. Accepts Name OR First Name + Last Name. Headers are case-insensitive. Max 1000 rows."
        previewColumns={[
          { field: "name", label: "Name" },
          { field: "firstName", label: "First" },
          { field: "lastName", label: "Last" },
          { field: "email", label: "Email" },
          { field: "title", label: "Title" },
          { field: "accountName", label: "Company" },
        ]}
      />
    </>
  );
}
